import React, { useState } from "react";
import { Modal, Button, notification } from "antd";
import {
  FacebookOutlined,
  TwitterOutlined,
  WhatsAppOutlined,
  CopyOutlined
} from "@ant-design/icons";
import { FaShareFromSquare } from "react-icons/fa6";

const ShareModal = ({ relativeUrl }) => {
  const [showModal, setShowModal] = useState(false);

  // Get the base domain from the window URL
  const baseDomain = window.location.origin;

  // The full URL that will be shared or copied
  const fullUrl = `${baseDomain}${relativeUrl}`;

  // Handle Copy Link to Clipboard
  const handleCopyLink = () => {
    navigator.clipboard.writeText(fullUrl).then(
      () => {
        // Show success notification
        notification.success({
          message: "Link Copied!",
          description: fullUrl
        });
      },
      (err) => {
        console.error("Failed to copy text: ", err);
        notification.error({
          message: "Copy Failed",
          description: "There was an issue copying the link."
        });
      }
    );
  };

  // Handle Share on Social Media
  const handleShare = (platform) => {
    const url = fullUrl;
    let shareUrl = "";

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
        break;
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
        break;
      default:
        break;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank", "width=600,height=400");
    }

    setShowModal(false); // Close the modal after sharing
  };

  return (
    <div>
      {/* Share Button to trigger Modal */}
      <Button
        onClick={() => setShowModal(true)}
        style={{
          border: "none",
          boxShadow: "none",
          color: "black",
          padding: "0",
          fontWeight: "500",
          fontSize: "15px",
          fontStyle: "italic",
          display: "flex",
          alignItems: "center",
          columnGap: "8px"
        }}>
        Share <FaShareFromSquare />
      </Button>

      {/* Modal for sharing options */}
      <Modal
        title="Share this link"
        open={showModal}
        onCancel={() => setShowModal(false)}
        centered
        footer={() => null}>
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
          <Button
            type="default"
            icon={<FacebookOutlined />}
            size="large"
            style={{ marginBottom: 10 }}
            onClick={() => handleShare("facebook")}>
            Share on Facebook
          </Button>

          <Button
            type="default"
            icon={<TwitterOutlined />}
            size="large"
            style={{ marginBottom: 10 }}
            onClick={() => handleShare("twitter")}>
            Share on Twitter
          </Button>

          <Button
            type="default"
            icon={<WhatsAppOutlined />}
            size="large"
            style={{ marginBottom: 10 }}
            onClick={() => handleShare("whatsapp")}>
            Share on WhatsApp
          </Button>

          <Button type="default" icon={<CopyOutlined />} size="large" onClick={handleCopyLink}>
            Copy Link
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ShareModal;
